module.exports = __webpack_public_path__ + "static/media/magician_temp.338b1073.jpg";